import React, { FunctionComponent, useEffect, useState } from 'react'
import { CurrentUserType } from '../../ducks/auth'
import Amplitude from '../../utils/amplitudeHelper'
import { PageStyle } from './styled'
import logo from '../../images/backdrops/header_titleM.png'
import { useWindowSize } from '../../utils/useWindowSize'
import Programme from 'src/components/Agenda/Programme'
import { useLocation } from 'react-router'

interface MobileAgendaTypes {
  currentUser: CurrentUserType
}

const MobileAgenda: FunctionComponent<MobileAgendaTypes> = ({ currentUser }) => {
  const { windowHeight } = useWindowSize()
  const [defaultHall, setDefaultHall] = useState(new URLSearchParams(useLocation()?.search).get("hall"))

  useEffect(() => {
    Amplitude.visit('Programme Page')
  }, [currentUser.id])


  return (
    <PageStyle mobileHeight={windowHeight}>
      <header>
        <div className="header-banner">
          <img src={logo} width="100%" className="d-block mx-auto" alt="event logo" />
        </div>
      </header>
      <section className="container mt-3">
        <Programme defaultDay={null} defaultHall={defaultHall} />
      </section>
    </PageStyle>
  )
}

export default MobileAgenda